import React, { useCallback, useEffect, useState } from "react";
import { useAdminAuth } from "./AdminAuthContext";
import { formatINR, fmtDate, StatusPill } from "./widgets";
import { X, Search } from "lucide-react";

export default function AdminCustomers() {
  const { apiFetch } = useAdminAuth();
  const [list, setList] = useState([]);
  const [q, setQ] = useState("");
  const [openEmail, setOpenEmail] = useState(null);
  const [detail, setDetail] = useState(null);

  const reload = useCallback(() => {
    apiFetch(`/admin/customers${q ? `?q=${encodeURIComponent(q)}` : ""}`)
      .then(({ data }) => setList(data || []))
      .catch(() => {});
  }, [q, apiFetch]);
  useEffect(() => { reload(); }, [reload]);

  useEffect(() => {
    if (!openEmail) { setDetail(null); return; }
    apiFetch(`/admin/customers/${encodeURIComponent(openEmail)}`)
      .then(({ data }) => setDetail(data))
      .catch(() => setDetail(null));
  }, [openEmail, apiFetch]);

  // Escape closes the drawer
  useEffect(() => {
    if (!detail) return;
    const onKey = (e) => { if (e.key === "Escape") setOpenEmail(null); };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [detail]);

  return (
    <>
      <div className="adm-page-head">
        <div>
          <h1 className="adm-h1">Customers</h1>
          <div className="adm-h1-sub">{list.length}, ranked by lifetime spend</div>
        </div>
        <div className="adm-search" style={{ width: 260 }}>
          <Search size={14} />
          <input className="adm-input" style={{ background: "transparent", border: 0, padding: 0, fontSize: 13 }} placeholder="Search email, name, city..." value={q} onChange={(e) => setQ(e.target.value)} />
        </div>
      </div>

      <div className="adm-card" style={{ padding: 0 }}>
        <table className="adm-table">
          <thead><tr><th>Customer</th><th>City</th><th style={{ textAlign: "right" }}>Orders</th><th style={{ textAlign: "right" }}>Spent</th><th>Last order</th></tr></thead>
          <tbody>
            {list.length === 0 ? <tr><td colSpan={5} className="adm-empty">No customers yet.</td></tr> :
              list.map((c) => (
                <tr key={c.email} className="clickable" onClick={() => setOpenEmail(c.email)}>
                  <td>{c.name || "-"}<div className="adm-cell-name-sub adm-mono">{c.email}</div></td>
                  <td className="adm-mono" style={{ color: "#8B8B93" }}>{c.city || "-"}</td>
                  <td className="adm-mono" style={{ textAlign: "right" }}>{c.total_orders}</td>
                  <td className="adm-mono" style={{ textAlign: "right" }}>{formatINR(c.total_spent)}</td>
                  <td className="adm-mono" style={{ color: "#8B8B93" }}>{c.last_order_at ? fmtDate(c.last_order_at) : "-"}</td>
                </tr>
              ))}
          </tbody>
        </table>
      </div>

      {detail && (
        <>
          <div className="adm-drawer-scrim" onClick={() => setOpenEmail(null)} />
          <div className="adm-drawer">
            <div className="adm-drawer-h">
              <div>
                <div className="adm-card-title">{detail.customer?.name || "Customer"}</div>
                <div className="adm-card-sub adm-mono">{detail.customer?.email}</div>
              </div>
              <button className="adm-icon-btn" onClick={() => setOpenEmail(null)}><X size={15} /></button>
            </div>
            <div className="adm-drawer-b">
              <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 14, marginBottom: 18 }}>
                <Stat label="Lifetime orders" value={detail.customer?.total_orders ?? 0} />
                <Stat label="Lifetime spent" value={formatINR(detail.customer?.total_spent || 0)} />
              </div>
              <div className="adm-label">Order history</div>
              <table className="adm-table">
                <thead><tr><th>Order</th><th>Status</th><th>Date</th><th style={{ textAlign: "right" }}>Total</th></tr></thead>
                <tbody>
                  {detail.orders.map((o) => (
                    <tr key={o.id}>
                      <td className="adm-mono">{o.id}</td>
                      <td><StatusPill status={o.status} /></td>
                      <td className="adm-mono" style={{ color: "#8B8B93" }}>{fmtDate(o.created_at)}</td>
                      <td className="adm-mono" style={{ textAlign: "right" }}>{formatINR(o.total)}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </>
      )}
    </>
  );
}

const Stat = ({ label, value }) => (
  <div className="adm-card" style={{ padding: 14 }}>
    <div className="adm-stat-label">{label}</div>
    <div className="adm-stat-value" style={{ fontSize: 20, marginTop: 6 }}>{value}</div>
  </div>
);
